import React from "react";

import { StyledDiffAmount } from "../../account/styledAccount";

const DiffAmountNotification = ({ balances, setBalances, diff }) => {
    const removeDiff = (e) => {
      if (e.target.id !== "amountDiff") {
        const index = balances.findIndex(balance => balance.diff);
        if (index > 0) {
          delete balances[index].diff;
          let newArr = [];
          setBalances([
            ...balances,
            ...newArr
          ]);
        }
        window.removeEventListener("click", removeDiff, false);
      }
    };

    if (!!diff) {
      window.addEventListener("click", removeDiff, false);
    }

    return (
      <StyledDiffAmount id="amountDiff" color={diff > 0 ? "green" : "red"} diff={!!diff}>
        <span>{diff}</span>
      </StyledDiffAmount>
    );
  }
;

export default DiffAmountNotification;